export enum CourseTag {
  ComingSoon,
  Free,
  EnrollingEnded,
}
